import { jsx as _jsx } from "react/jsx-runtime";
export function Button({ variant = 'primary', className = '', children, ...props }) {
    return (_jsx("button", { className: `sa-button sa-button--${variant} ${className}`.trim(), ...props, children: children }));
}
//# sourceMappingURL=Button.js.map